// extracted by css-extract-rspack-plugin
export default {"signalIcon":"iYUsc791UEsY1tI0__signalIcon___","label":"Fx69uavPdpgkVFos__label___"};